export default {
      id: "home_repair_service-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#home_repair_service",
      toString: function () {
        return this.url;
      }
    }